import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";

const STARTERS = [
  "How do I care for a turtle wound?",
  "What is the best substrate for a sick frog?",
  "What is the difference between a painted turtle and a mud turtle?",
];

export default function WelcomeMessage({ onSuggestionClick }) {
  return (
    <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
      <Avatar
        src="/images/susie-avatar.png"
        alt="Susie"
        sx={{ width: 120, height: 120, bgcolor: "secondary.main", fontSize: 20 }}
      >
        🐢
      </Avatar>
      <Box>
        <Box
          sx={{
            bgcolor: "background.paper",
            border: 1,
            borderColor: "divider",
            borderRadius: "12px 12px 12px 2px",
            px: 2,
            py: 1.5,
            maxWidth: 480,
          }}
        >
          <Typography variant="body1" sx={{ fontSize: 18, lineHeight: 1.7 }}>
            Hi! I'm Susie, one of SERC's ambassador box turtles. Ask me
            about husbandry, wound care, enclosure setup, or anything
            else to help with your rehab work!
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1.5 }}>
          {STARTERS.map((q) => (
            <Chip
              key={q}
              label={q}
              variant="outlined"
              onClick={() => onSuggestionClick(q)}
              sx={{
                borderColor: "divider",
                color: "text.secondary",
                fontFamily: "'PT Serif', Georgia, serif",
                fontSize: 15,
                "&:hover": { bgcolor: "background.paper" },
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
